/**
 * 📦 Constantes de tipos de ítems de productos o servicios (CAT-011).
 *
 * ✅ Estas constantes corresponden a los valores oficiales del catálogo CAT-011.
 * Se usan para distinguir si un ítem es un bien, servicio, ambos o tributos.
 */

export const ITEM_TYPE_CODES = {
  GOODS: 1,          // Bienes
  SERVICES: 2,       // Servicios
  BOTH: 3,           // Bienes y Servicios
  OTHER_TAXES: 4,    // Otros tributos por ítem
} as const;

export type ItemTypeCode = typeof ITEM_TYPE_CODES[keyof typeof ITEM_TYPE_CODES];
